/* © 2016 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 2016
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

module.exports = function (config, get, post, upload) {
	return {
		list: {
			core: list_core_forms,
			forms: list_forms_by_ids,
			group: list_group_forms,
			own: list_own_forms,
			definitions: list_definitions
		},
		survey: {
			update: update, // to respond to a survey
			pending: list_pending, // list of surveys a person has rx'ed but not responded to
		},
		submission: {
			group: {
				create: create_group_submission,
				update: update_group_submission,
				delete: delete_group_submission,
				search: search_group_submission,
				lock: lock_group_submission,
				file: file_group_submission,
				own: {
					create: create_own_submission,
					update: update_own_submission,
					delete: delete_own_submission,
					search: search_own_submission,
					prepopulate: fetch_own_prepopulate,
					lock: lock_own_submission,
					file: file_own_submission
				}
			},
		}
	};

	function list_core_forms() {
		return get("/v2/forms/list/core");
	}

	function list_forms_by_ids(forms) {
		return get("/v2/forms/list", {
			forms: forms
		});
	}

	function list_group_forms(targetType){
		var target = targetType || null;

		return get("/v2/forms/list/group", {
			targetType: target
		});
	}

	function create_group_submission(form, data, owner) {
		return post("/v2/forms/submission/group/create", {
			form: form,
			data: data,
			owner: owner
		});
	}

	function update_group_submission(submission, data) {
		return post("/v2/forms/submission/group/update", {
			submission: submission,
			data: data
		});
	}

	function delete_group_submission(submission) {
		return post("/v2/forms/submission/group/delete", {
			submission: submission
		});
	}

	function search_group_submission(form, start, end, page) {
		return get("/v2/forms/submission/group/search", {
			form: form,
			start: start,
			end: end,
			page: page
		});
	}

	function lock_group_submission(submission) {
		return post("/v2/forms/submission/group/lock", {
			submission: submission
		});
	}

	function list_own_forms(){
		return get("/v2/forms/list/group/own");
	}

	function update(submission, data) {
		return post("/v2/survey/update", {
			submission: submission,
			data: data
		});
	}

	function list_pending() {
		return get("/v2/survey/list/pending");
	}

	function create_own_submission(form, data) {
		return post("/v2/forms/submission/group/own/create", {
			form: form,
			data: data,
		});
	}

	function update_own_submission(submission, data) {
		return post("/v2/forms/submission/group/own/update", {
			submission: submission,
			data: data
		});
	}

	function delete_own_submission(submission) {
		return post("/v2/forms/submission/group/own/delete", {
			submission: submission
		});
	}

	function search_own_submission(form, start, end, page) {
		return get("/v2/forms/submission/group/own/search", {
			form: form,
			start: start,
			end: end,
			page: page
		});
	}

	function fetch_own_prepopulate(form) {
		return get("/v2/forms/submission/group/own/prepopulate", {
			form: form
		});
	}

	function lock_own_submission(submission) {
		return post("/v2/forms/submission/group/own/lock", {
			submission: submission
		});
	}

	function list_definitions(definition) {
		return get("/v2/forms/list/definitions", {
			list: definition
		});
	}

	function file_group_submission(file){
		return upload("/v2/forms/submission/group/file", {}, "file", file);
	}

	function file_own_submission(file){
		return upload("/v2/forms/submission/group/own/file", {}, "file", file);
	}
};
